import styled from 'styled-components';

// Main Window Components
export const Overlay = styled.div`
  position: fixed;
  z-index: 10;
  background-color: white;
  height: 100%;
  width: 100%;
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 5px);
`;
